import { Component, computed, effect, inject } from '@angular/core';
import { ALL_COMMON_MODULES } from '../../../shared';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonService } from '../../../services/common.service';
import { ErrorPageComponent } from '../../../feature/error-page/error-page.component';
import { ReportService } from '../../../services/report.service';

@Component({
    selector: 'app-side-bar',
    imports: [ALL_COMMON_MODULES, ErrorPageComponent],
    templateUrl: './side-bar.component.html',
    styleUrl: './side-bar.component.scss'
})
export class SideBarComponent {
  private commonService = inject(CommonService);
  public router = inject(Router);
  public isAdmin = localStorage.getItem('admin') === 'true';

  isLoading = false;
  hasError = false;

  // ...existing code...

  private handleDataLoad() {
    this.isLoading = true;
    this.hasError = false;
  }

  sidenavVisible = false;

  constructor(route: ActivatedRoute,private powerbi: ReportService) {

    effect(()=>{
      this.sidenavVisible = this.commonService.sidenavVisible();
    })

    effect(() => {
      this.isAdmin = this.commonService.isAdmin();
    })
  }

  onSearchDatabaseClick() {
    // Navigate to the search database page
    this.router.navigate(['/search-database']);
    // Ensure sidenav is visible when navigating to search database
    this.commonService.setSidenavVisible(true);
  }
   async downloadReport(type:number) {
    const accessToken = sessionStorage.getItem('PowerBiAuthToken') || '';
    const blob = await this.powerbi.exportReport(0,accessToken,type);
    if (blob) {
      const url = window.URL.createObjectURL(blob);
      
      // Open the URL in a new tab
      // const newTab = window.open(url, '_blank');
      // if (newTab) {
      //   newTab.focus();
      // } else {
      //   console.error('Failed to open image in a new tab. Please allow popups for this website.');
      // }

      // Alternatively, trigger a download
      const a = document.createElement('a');
      a.href = url;
      a.download = 'DownloadedReport.pdf';
      a.click();
      window.URL.revokeObjectURL(url);
    }
  }
  

}
